import { getAppConfig } from 'app/getConfig';

export const getGTMKey = () => {
  return getAppConfig().SURVEY_UI_GTM_KEY;
};
